<template>
  <div class="row">
    <PublicHeader :title="detalhes.dado.nome">
      <div class="col-xs-12">
        <p class="text-xl">
          {{ detalhes.dado.descricao }}
        </p>
      </div>
      <div class="col-xs-12">
        <ul id="bandeiras">
          <li v-for="ods in detalhes.bandeiras" :key="ods.codigo">
            <a
              :href="ods.link"
              target="_blank"
              :title="ods.titulo"
              data-toggle="popover"
              data-placement="top"
              data-trigger="hover"
              :data-content="ods.objetivo"
            >
              <img :src="imgPath + ods.imagem" :alt="ods.titulo" />
            </a>
          </li>
        </ul>
      </div>
    </PublicHeader>

    <div class="container">
      <Breadcrumb :links="breadcrumblinks" />
      <InfoDados
        type="single"
        title="Fonte"
        :description="detalhes.dado.fonte"
      />
      <InfoDados type="list" title="Assuntos" :list="detalhes.eixos" />
      <InfoDados
        type="list"
        title="Programas Municipais"
        :list="detalhes.tags"
      />
      <InfoDados
        type="list"
        title="Secretarias / Órgãos"
        :list="detalhes.secretarias"
      />
      <Downloads />
      <Graficos :detalhes="detalhes" :valores="valores" />
      <TabelaValores :detalhes="detalhes" :valores="valores" />
    </div>
  </div>
</template>

<script>
import { request } from '@/request'

import {
  PublicHeader,
  Breadcrumb,
  InfoDados,
  Downloads,
  Graficos,
  TabelaValores
} from '../../../components'

export default {
  name: 'Detalhes',
  components: {
    PublicHeader,
    Breadcrumb,
    InfoDados,
    Downloads,
    Graficos,
    TabelaValores
  },
  data() {
    return {
      imgPath: this.$root.$data.imgUrl,
      detalhes: {
        dado: {
          tipo: 'T'
        },
        eixos: [],
        bandeiras: [],
        tags: [],
        valores: [],
        secretarias: []
      },
      valores: []
    }
  },
  methods: {
    voltar() {
      this.$router.go(-1)
    },
    fetchInfos(url, keyOrFunction) {
      const resFunction =
        typeof keyOrFunction === 'string'
          ? ({ data }) => {
              if (Object.keys(data).length > 0) {
                this.detalhes[keyOrFunction] = data[keyOrFunction]
              }
            }
          : keyOrFunction

      request
        .get(url + this.$route.params.id)
        .then(resFunction)
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  computed: {
    breadcrumblinks() {
      const baseRoute =
        this.$route.query.origem === 'dados-secretaria'
          ? '/listar/dados-secretaria'
          : '/listar/dados'

      return [{ label: 'Listagem', link: baseRoute }, { label: 'Detalhes' }]
    }
  },
  created() {
    this.fetchInfos('detalhes/', ({ data }) => {
      if (Object.keys(data).length) {
        const { dado, valores } = data
        this.detalhes.dado = dado
        this.detalhes.valores = valores
      }
    })

    this.fetchInfos('detalhes/valores2/', ({ data }) => {
      this.valores = data
    })

    this.fetchInfos('detalhes/secretarias/', ({ data }) => {
      if (Object.keys(data).length > 0) {
        this.detalhes.secretarias = data.secretarias.map(secretaria => {
          return {
            codigo: secretaria.sigla,
            descricao: `${secretaria.sigla} - ${secretaria.nome}`
          }
        })
      }
    })

    this.fetchInfos('detalhes/eixos/', 'eixos')
    this.fetchInfos('detalhes/bandeiras/', 'bandeiras')
    this.fetchInfos('detalhes/tags/', 'tags')
  },
  updated() {
    window.jQuery('[data-toggle="popover"]').popover({})
  }
}
</script>

<style scoped>
#bandeiras {
  padding-left: 0px;
}
#bandeiras {
  list-style-type: none;
}
#bandeiras > li {
  max-width: 70px;
  float: left;
}
#bandeiras > li > a > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/public/dados/details.vue